// extracted by mini-css-extract-plugin
export var emptyState = "_5e-d";
export var statCard = "_5e-c";
export var table = "_5e-0";
export var tableCell = "_5e-4";
export var tableCellClickable = "_5e-5 _5e-4";
export var tableCellDefault = "_5e-6 _5e-4";
export var tableCellEmpty = "_5e-8";
export var tableCellWithValue = "_5e-7";
export var tableContainer = "_5e-e";
export var tableHeaderWeight = "_5e-1";
export var tableHeaderZone = "_5e-2";
export var tableRowHeader = "_5e-3";
export var viewModeButton = "_5e-9";
export var viewModeButtonActive = "_5e-a _5e-9";
export var viewModeButtonInactive = "_5e-b _5e-9";